// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum enumName_templates {
  PaperOrientation = "PaperOrientation",
  PaperSize = "PaperSize",
  TemplateDesignFieldType = "TemplateDesignFieldType",
  TemplateGenericType = "TemplateGenericType",
  TemplateGroup = "TemplateGroup",
  TemplateSectionType = "TemplateSectionType",
}
